/*
 Copyright 2026 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the
 project root for license information.
*/

/**
 * Cite API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SystemPermission = {
    CreateScoringModels: 'CreateScoringModels',
    ViewScoringModels: 'ViewScoringModels',
    EditScoringModels: 'EditScoringModels',
    ManageScoringModels: 'ManageScoringModels',
    CreateEvaluations: 'CreateEvaluations',
    ViewEvaluations: 'ViewEvaluations',
    EditEvaluations: 'EditEvaluations',
    ManageEvaluations: 'ManageEvaluations',
    ExecuteEvaluations: 'ExecuteEvaluations',
    ObserveEvaluations: 'ObserveEvaluations',
    ViewUsers: 'ViewUsers',
    ManageUsers: 'ManageUsers',
    ViewRoles: 'ViewRoles',
    ManageRoles: 'ManageRoles',
    ViewGroups: 'ViewGroups',
    ManageGroups: 'ManageGroups',
    ViewTeamTypes: 'ViewTeamTypes',
    ManageTeamTypes: 'ManageTeamTypes'
} as const;
export type SystemPermission = typeof SystemPermission[keyof typeof SystemPermission];

